module.exports = __webpack_public_path__ + "img/WeChatpay.7c82a642.svg";